import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import type { TreatmentFaq } from "@/content/treatments-content"

interface TreatmentFaqsProps {
	faqs: TreatmentFaq[]
}

/** Sección 3: preguntas frecuentes del tratamiento en un acordeón. */
export function TreatmentFaqs({ faqs }: TreatmentFaqsProps): React.JSX.Element {
	return (
		<section className="bg-muted/40">
			<Container className="py-16 md:py-24">
				<div className="mx-auto max-w-3xl">
					<div className="text-center">
						<Eyebrow align="center">Preguntas frecuentes</Eyebrow>
						<h2 className="mt-3 text-balance font-heading text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">
							Resolvemos tus dudas
						</h2>
					</div>
					<Accordion type="single" collapsible className="mt-10 bg-background">
						{faqs.map((faq, i) => (
							<AccordionItem key={i} value={`faq-${i}`}>
								<AccordionTrigger className="text-base">{faq.q}</AccordionTrigger>
								<AccordionContent className="text-muted-foreground">{faq.a}</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				</div>
			</Container>
		</section>
	)
}
